import { format, isAfter } from '@formkit/tempo';
import { formatISO } from 'date-fns';

export function fixTime(
	time: string | null | undefined,
	rangeCheck: boolean = false,
) {
	if (!time) return time;
	const [hoursStr, minutesStr] = time.split(':');
	if (!hoursStr) return null;
	const hours = Number(hoursStr);
	const minutes =
		!minutesStr || minutesStr.length === 0 ? 0
		: minutesStr.length === 1 ? Number(minutesStr) * 10
		: Number(minutesStr);
	if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
	if (rangeCheck && (hours < 0 || hours > 23 || minutes < 0 || minutes > 59))
		return null;
	return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

export function padTime(time: string | null | undefined) {
	return fixTime(time)?.concat(':00');
}

export const safeFormat = (...args: Parameters<typeof format>) => {
	try {
		return format(...args);
	} catch {
		return String(args[0]);
	}
};

export const formatTimestamp = (date: string) => {
	const formattedDate = formatDate(new Date(date));
	if (!formattedDate) return undefined;
	return `${formattedDate}T00:00:00.000Z`;
};

export const formatTimestampWithParseDate = (date: string) => {
	const formattedDate = formatDate(parseDate(date));
	if (!formattedDate) return undefined;
	return `${formattedDate}T00:00:00.000Z`;
};

export const parseDate = (value: string | null | undefined) => {
	if (!value) {
		return null;
	}
	const [yearText, monthText, dayText] = value.split('-');
	const year = Number(yearText);
	const month = Number(monthText);
	const day = Number(dayText);
	if (
		!Number.isInteger(year) ||
		!Number.isInteger(month) ||
		!Number.isInteger(day)
	) {
		return null;
	}
	return new Date(year, month - 1, day);
};

export const formatDate = (date: Date | null | undefined) =>
	date && !isNaN(+date) && isAfter(date, new Date(1900, 0, 1)) ?
		formatISO(date, { representation: 'date' })
	:	undefined;
